import { useCallback, useEffect, useState } from "react"
import Content from "../../components/Content"
import Header from "../../components/Header"
import InputText from "../../components/InputText"
import RecordInterface from "../../interfaces/Record.interface"
import { getRecords } from "../../services/record.services"
import { toast } from "react-toastify"
import { Download, Loader } from "lucide-react"
import config from "../../config"
import Button from "../../components/Button"
import { formatToLocalDateTime } from "../../utils/time"

const RecordsPage = () => {
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [records, setRecords] = useState<RecordInterface[]>([])
    const [currentPage, setCurrentPage] = useState(0)
    const [order, setOrder] = useState("desc")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    const search: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault()
        setLoading(true)
        getRecords({ page: 0, order, startDate: startDate.length === 0 ? "none" : startDate, endDate: endDate.length === 0 ? "none" : endDate })
            .then((res) => {
                setRecords(res.data.payload.records)
                setLoading(false)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => {
                setLoading(false)
                setCurrentPage(0)
            })
    }

    const loadMore = () => {
        setLoadingMore(true)
        getRecords({ page: currentPage + 1, order, startDate: startDate.length === 0 ? "none" : startDate, endDate: endDate.length === 0 ? "none" : endDate })
            .then((res) => {
                let recs = [...records]
                recs.concat(res.data.payload.records)
                setRecords(records.concat(res.data.payload.records))
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => {
                setLoadingMore(false)
                setCurrentPage(currentPage + 1)
            })
    }

    useEffect(() => {
        getRecords({ page: currentPage, order, startDate: startDate.length === 0 ? "none" : startDate, endDate: endDate.length === 0 ? "none" : endDate })
            .then((res) => {
                setRecords(res.data.payload.records)
                setLoading(false)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return (
        <div>
            <Header className="bg-[#faa700]">
                <p className="text-white font-extrabold uppercase text-4xl">Grabaciones</p>
                <p className="text-white">Encuentra las grabación del partido que jugaste acá.</p>
            </Header>

            <Content className="flex flex-col gap-10">
                <div className="flex flex-col gap-2 border rounded p-5">
                    <p className="text-lg text-zinc-700">Buscar</p>
                    <form className="flex flex-col gap-5" onSubmit={search}>
                        <div className="flex flex-col md:flex-row gap-5">
                            <div className="w-full flex flex-col">
                                <p className="text-sm uppercase text-zinc-700">
                                    Rango inicial fecha
                                </p>
                                <InputText type="date" onChange={(event) => setStartDate(event.target.value)} value={startDate} />
                            </div>
                            <div className="w-full flex flex-col">
                                <p className="text-sm uppercase text-zinc-700">
                                    Rango final fecha
                                </p>
                                <InputText type="date" onChange={(event) => setEndDate(event.target.value)} value={endDate} />
                            </div>
                        </div>
                        <div>
                            <Button className="self-start">Buscar</Button>
                        </div>
                    </form>
                </div>

                {loading ?
                    <div className="flex justify-center items-center">
                        <Loader />
                    </div>
                    :
                    <div className="flex flex-col gap-5">
                        {records.length > 0 ?
                            records.map((record) => (
                                <div key={record.id} className="flex flex-col gap-2 border p-5 rounded">
                                    <div className="flex items-center justify-between">
                                        <p className="text-zinc-700 text-lg">{formatToLocalDateTime(record.created_at)}</p>
                                        <a className="text-blue-500" href={`${config.API_URL}/records/${record.id}/download/${record.name}`} download={record.name}><Download /></a>
                                    </div>
                                </div>
                            ))
                            :
                            <p className="text-sm uppercase text-zinc-700">No hay grabaciones para este rango de fechas.</p>
                        }
                        <Button spinner={loadingMore} disabled={loadingMore} onClick={loadMore}>Cargar más</Button>
                    </div>
                }

            </Content>
        </div>
    )
}

export default RecordsPage